"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _stylitas = require("@creditas/stylitas");

var _GhostButton = require("../../GhostButton");

var Button = (0, _stylitas.styled)(_GhostButton.GhostButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 32px;\n"])));
exports.Button = Button;